import { CurrentToolUsage, useIsOwnerQuery } from "@/store/services/supabase";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
const DetailsButton = () => <Link href="/settings/org/usage" target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-component="DetailsButton" data-sentry-source-file="ScreeningFairUseWarning.tsx">
    <Button size="small" type="text" data-sentry-element="Button" data-sentry-source-file="ScreeningFairUseWarning.tsx">
      Details {<ArrowRightOutlined />}
    </Button>
  </Link>;
const ScreeningFairUseWarning = ({
  currentUsage,
  hideDetail = false
}: {
  currentUsage: CurrentToolUsage;
  hideDetail?: boolean;
}) => {
  const {
    data: isOwner,
    isFetching,
    isLoading
  } = useIsOwnerQuery();
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "screening.uploadLimitAlert"
  });

  // Do not show if in process of loading data.
  if (isFetching || isLoading) {
    return <></>;
  }
  return <>
      {currentUsage.showWarning === "warn" && <Alert type="warning" className="mb-4" showIcon action={!hideDetail && isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.warning") : t("user.warning")}</Markdown>} />}

      {currentUsage.showWarning === "error" && <Alert type="error" className="mb-4" showIcon action={!hideDetail && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.error") : t("user.error")}</Markdown>} />}
    </>;
};
export default ScreeningFairUseWarning;